import type { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import type { AuthStore } from "../stores/auth.store"; // Import the type for your store
import {useAuthStore} from "@/stores/auth.store";


const setup = (instance: AxiosInstance) => {
    let store = useAuthStore();

    instance.interceptors.request.use(
        (config) => {
            // If user is authenticated, place access token in request header.
            if (store.authenticated()) {
                config.headers["Authorization"] = "Bearer " + store.user.authInfo.token;
            }


            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    instance.interceptors.response.use(
        (res) => {
            return res;
        },
        async (error: AxiosError) => {
            const oriConfig = error.config as any;

            if (error.response?.status === 401 && !oriConfig._retry) {
                oriConfig._retry = true;

                try {
                    // Refresh token then retry once
                    await store.refreshUserToken();

                    // Place refreshed access token in the request header
                    oriConfig.headers["Authorization"] = "Bearer " + store.user.authInfo.token;

                    return instance(oriConfig);
                } catch (_error) {
                    console.error("Refresh token failed");
                    console.error(_error);

                    return Promise.reject(_error);
                }
            }

            return Promise.reject(error);
        }
    );
};

export default setup;
